import { BUSINESS_TOOL_SUB_SECTIONS } from 'constants/businessTool';

import { ul } from './helpers';
import {
  ABOUT_COMPANY_HISTORY_NAMES,
  LIST_OF_KEY_EVENTS_FIELDS,
} from '../Sections/AboutCompany/CompanyHistory/utils/form';
import { ABOUT_COMPANY_GENERAL_NAMES, LIST_OF_FOUNDERS_FIELDS } from '../Sections/AboutCompany/GeneralInfo/utils/form';
import { ABOUT_COMPANY_MISSION_NAMES, GOAL_ROW_NAMES } from '../Sections/AboutCompany/MissionAndVision/utils/form';
import { ABOUT_COMPANY_SWOT_NAMES, SWOT_ROW_NAMES } from '../Sections/AboutCompany/SWOT/utils/form';

const SOCIAL_NETWORKS_INSTRUCTION_TEXT =
  'List the social networks your company uses, along with their respective links. Ensure all links are accurate and lead to your official profiles.';
const FOUNDERS_INSTRUCTION_TEXT =
  "Please provide a comprehensive list of your company's founders. Include their full names and specify the percentage of ownership each founder holds.";

const LIST_OF_FOUNDERS_INSTRUCTIONS = {
  [LIST_OF_FOUNDERS_FIELDS.FIRST_NAME]: {
    name: 'First Name',
    instruction: FOUNDERS_INSTRUCTION_TEXT,
    exampleOne: '',
    exampleTwo: '',
  },
  [LIST_OF_FOUNDERS_FIELDS.LAST_NAME]: {
    name: 'Last Name',
    instruction: FOUNDERS_INSTRUCTION_TEXT,
    exampleOne: '',
    exampleTwo: '',
  },
  [LIST_OF_FOUNDERS_FIELDS.SHARE_IN_COMPANY]: {
    name: 'Founders List',
    instruction: FOUNDERS_INSTRUCTION_TEXT,
    exampleOne: '',
    exampleTwo: '',
  },
};

const GENERAL_INFO_INSTRUCTIONS = {
  [ABOUT_COMPANY_GENERAL_NAMES.LEGAL_STRUCTURE]: {
    name: 'Legal Structure',
    instruction:
      'State the legal structure of your company. Options include sole proprietorship, partnership, corporation, or limited liability company (LLC).',
    exampleOne: 'Limited Liability Company',
    exampleTwo: 'Sole Proprietorship',
  },
  [ABOUT_COMPANY_GENERAL_NAMES.WEBSITE_URL]: {
    name: 'Website',
    instruction: "Share your company's full web address",
    exampleOne: 'agrotech.com',
    exampleTwo: 'languagelab.com',
  },
  [ABOUT_COMPANY_GENERAL_NAMES.PHONE]: {
    name: 'Phone',
    instruction:
      'Offer a reliable contact phone number for your company,  include area code and any necessary extension details.',
    exampleOne: '+1 484 111 11 11',
    exampleTwo: '+1 584 741 21 82',
  },
  [ABOUT_COMPANY_GENERAL_NAMES.EMAIL]: {
    name: 'E-mail',
    instruction:
      'Provide the official email address of the company accurately, include the domain name and any relevant department or contact details.',
    exampleOne: 'info@agrotech.com',
    exampleTwo: 'info@languagelab.com',
  },
  [ABOUT_COMPANY_GENERAL_NAMES.FACEBOOK]: {
    name: 'Facebook',
    instruction: SOCIAL_NETWORKS_INSTRUCTION_TEXT,
    exampleOne: 'www.facebook.com/agrotech/',
    exampleTwo: 'www.facebook.com/languagelab/',
  },
  [ABOUT_COMPANY_GENERAL_NAMES.LINKEDIN]: {
    name: 'Linkedin',
    instruction: SOCIAL_NETWORKS_INSTRUCTION_TEXT,
    exampleOne: '',
    exampleTwo: '',
  },
  [ABOUT_COMPANY_GENERAL_NAMES.INSTAGRAM]: {
    name: 'Instagram',
    instruction: SOCIAL_NETWORKS_INSTRUCTION_TEXT,
    exampleOne: '',
    exampleTwo: '',
  },
  [ABOUT_COMPANY_GENERAL_NAMES.OTHER]: {
    name: 'Other social networks',
    instruction: SOCIAL_NETWORKS_INSTRUCTION_TEXT,
    exampleOne: '',
    exampleTwo: '',
  },
  // TODO add the names here
  [ABOUT_COMPANY_GENERAL_NAMES.FIRST_NAME]: {
    name: 'First Name',
    instruction:
      'Ensure to provide the complete legal name of your primary contact person. Double-check the spelling and format to avoid any errors.',
    exampleOne: 'John',
    exampleTwo: 'Sam',
  },
  [ABOUT_COMPANY_GENERAL_NAMES.LAST_NAME]: {
    name: 'Last Name',
    instruction:
      'Ensure to provide the complete legal name of your primary contact person. Double-check the spelling and format to avoid any errors.',
    exampleOne: 'Johnson',
    exampleTwo: 'Doe',
  },
  [ABOUT_COMPANY_GENERAL_NAMES.POSITION]: {
    name: 'Position',
    instruction:
      "State the official job title as recognized within your company. Specify if the contact person is an owner, consultant, or another position. Confirm that the title accurately reflects the person's role and responsibilities within the company.",
    exampleOne: 'CEO, Founder',
    exampleTwo: 'CFO',
  },
  [ABOUT_COMPANY_GENERAL_NAMES.CONTACT_PERSON_EMAIL]: {
    name: 'Email',
    instruction:
      'Provide the official email address of the primary contact person accurately, include the domain name and any relevant department or contact details.',
    exampleOne: 'ceo@agrotech.com',
    exampleTwo: 'ceo@languagelab.com',
  },
  [ABOUT_COMPANY_GENERAL_NAMES.CONTACT_PERSON_PHONE]: {
    name: 'Contact Phone Number',
    instruction:
      'Offer a reliable contact phone number for the primary contact person, include area code and any necessary extension details.',
    exampleOne: '+1 484 111 11 11',
    exampleTwo: '+1 464 111 35 93',
  },
  [ABOUT_COMPANY_GENERAL_NAMES.LIST_OF_FOUNDERS]: LIST_OF_FOUNDERS_INSTRUCTIONS,
};

const LIST_OF_KEY_EVENTS_FIELDS_INSTRUCTIONS = {
  [LIST_OF_KEY_EVENTS_FIELDS.TITLE]: {
    name: 'Key Historical Events',
    instruction:
      'Briefly introduce your business`s founding and early milestones, including the market gap that sparked its creation. Highlight initial achievements like company registration, license acquisition, or prototype development.',
    exampleOne:
      'In 2020, the Company launched its first tracked tractor model, revolutionizing farming in challenging soils with superior traction and flotation.',
    exampleTwo:
      'In 2021, the language platform launched its AI-powered translation feature, revolutionizing multilingual communication.',
  },
  [LIST_OF_KEY_EVENTS_FIELDS.DATE]: {
    name: 'Date',
    instruction: 'Specify the date of the event accurately, including the month and year',
    exampleOne: '',
    exampleTwo: '',
  },
};

const COMPANY_HISTORY_INSTRUCTIONS = {
  [ABOUT_COMPANY_HISTORY_NAMES.BUSINESS_IDEA_CONCEPTION]: {
    name: 'Business Idea Origin',
    instruction:
      'Share business idea genesis: circumstances, challenges, observations sparking concept. Discuss market gaps, trends, personal experiences leading to opportunity.',
    exampleOne:
      'The business idea stemmed from John Johnson`s firsthand experience when he encountered challenges related to heavy or wet soils that hindered traditional tractor performance. Together with Oliver Smith, they identified an opportunity to develop tracked tractors with superior traction and flotation, addressing the specific needs of farmers working in challenging soil conditions.',
    exampleTwo:
      'The idea for the platform emerged from the chaotic and unsystematic nature of the translation services market. Clients often needed help finding suitable specialists and verifying their competence, while translators faced risks such as non-payment after completing work.',
  },
  [ABOUT_COMPANY_HISTORY_NAMES.MOTIVATION]: {
    name: 'Creation Reason',
    instruction:
      'Clearly articulate the primary purpose of the business idea creation. Specify the motivations and goals that inspired this business concept, emphasizing the more significant impact or positive change. ',
    exampleOne:
      'The Company was created to address a gap in the agricultural machinery market for specialized tractors capable of effectively working in heavy or wet soils. As owner of a farm, John Johnson recognized the limitations of conventional wheeled tractors in such conditions and saw an opportunity to innovate.',
    exampleTwo:
      'The platform connects translators and clients, offering convenience and efficiency in finding, ordering, and paying for translation services. All communication and transactions are secure within the platform, filling a market gap with a reliable and transparent solution for high-quality translations.',
  },
  [ABOUT_COMPANY_HISTORY_NAMES.EVENTS]: LIST_OF_KEY_EVENTS_FIELDS_INSTRUCTIONS,
};

const GOALS_INSTRUCTIONS = {
  [GOAL_ROW_NAMES.GOAL]: {
    name: 'Goal',
    instruction:
      'Outline company strategic goals, emphasizing short, medium, long-term objectives aligned with mission and vision. Specify focus areas like market expansion, revenue growth, or product innovation. Discuss strategies, initiatives, KPIs driving goal realization.',
    exampleOne:
      'Long-term: Achieve global market leadership by diversifying product offerings, investing in research and development for sustainable farming technologies, and expanding into emerging markets.',
    exampleTwo:
      'Short-term: Enhance platform usability with new features, increase user base through targeted marketing campaigns.',
  },
  [GOAL_ROW_NAMES.PRIORITY]: {
    name: 'Priority',
    instruction: "Indicate the priority of the goal succinctly, highlighting whether it's high, low or middle.",
    exampleOne: '',
    exampleTwo: '',
  },
  [GOAL_ROW_NAMES.TERMS]: {
    name: 'Terms',
    instruction: "Indicate the term of the goal succinctly, highlighting whether it's long-term or short-term.",
    exampleOne: '',
    exampleTwo: '',
  },
  [GOAL_ROW_NAMES.SCHEDULED_DATE]: {
    name: 'Scheduled  date',
    instruction: 'Specify the date of the goal accurately, including the month and year.',
    exampleOne: '',
    exampleTwo: '',
  },
  [GOAL_ROW_NAMES.MECHANISM_OF_ACHIEVEMENT]: {
    name: 'Mechanism  of achievement',
    instruction:
      'Delve into the mechanisms and strategies employed to achieve your business goals. Discuss the specific initiatives, action plans, or operational frameworks put in place to realize each goal.',
    exampleOne:
      'Diversify products, invest in R&D for sustainable farming tech, and expand into emerging markets, ensuring long-term growth and competitiveness.',
    exampleTwo:
      'Implement user feedback loop for feature prioritization, roll out intuitive updates regularly. Execute targeted marketing campaigns across digital channels to attract and engage new users, driving platform growth.',
  },
};

const MISSION_NAMES_INSTRUCTIONS = {
  [ABOUT_COMPANY_MISSION_NAMES.VISION_OF_FUTURE]: {
    name: 'Vision Statement',
    instruction:
      'Express long-term goals shaping organization`s future. Emphasize transformative impact on industry or community. Clearly state desired outcomes and company`s role. Align vision with core values, reflecting positive impact and essence of company.',
    exampleOne:
      'The Company`s vision is to lead the agricultural industry into a technologically advanced future where our innovative tractor solutions serve as catalysts for increased productivity, environmental stewardship, and economic prosperity worldwide.',
    exampleTwo:
      'The Company`s vision is to lead the language services industry through innovative technology and ethical practices, fostering global connectivity.',
  },
  [ABOUT_COMPANY_MISSION_NAMES.CORE_VALUES]: {
    name: 'Company Values',
    instruction:
      'Outline company`s core values. Define fundamental principles shaping organizational culture. Discuss alignment with mission and identity. Emphasize values` role in guiding employee behavior, fostering positive work environment, and promoting ethical practices.',
    exampleOne:
      'The company`s core values prioritize innovation, integrity, and sustainability, guiding every decision and fostering a culture of excellence and responsibility.',
    exampleTwo:
      'The language platform values inclusively, accuracy, and user-centricity, ensuring accessible and reliable communication solutions for all.',
  },
  [ABOUT_COMPANY_MISSION_NAMES.PROBLEM_OF_MARKET]: {
    name: 'Problem Definition',
    instruction:
      'Briefly outline market context and specific problem or need. Articulate industry challenges, emphasizing impact on stakeholders. Identify market gaps creating opportunity for business.',
    exampleOne:
      'Conventional wheeled tractors struggle in heavy or wet soils, causing reduced traction, slippage, and soil compaction. This hinders farm productivity, affecting planting, cultivating, and harvesting, resulting in lower yields and increased operational costs.',
    exampleTwo:
      'The language services industry lacks an efficient process, causing delays and communication breakdowns. Clients struggle to find suitable translators, while translators need help marketing and vetting clients. A reliable platform is crucial to streamline collaboration and foster trust in global business operations.',
  },
  [ABOUT_COMPANY_MISSION_NAMES.HOW_PROJECT_ADDRESSES_THE_PROBLEM]: {
    name: 'Contribution to Problem Solving',
    instruction:
      'State business plan subject, highlighting unique solution elements. Outline core features, emphasizing problem-solving approach. Discuss strategic approach, including innovative tech or value propositions. Articulate benefits and outcomes for stakeholders.',
    exampleOne:
      'The business plan focuses on developing specialized tracked tractors with patented continuous track technology, addressing productivity challenges in heavy soils. These tractors offer extended lifespans and cost-effectiveness, reducing operational expenses and enhancing profitability for farmers.',
    exampleTwo:
      'The Company resolves the decentralization of translation services with a centralized platform, robust vetting, secure payments, and AI-driven technology. The company strategy leverages technology to streamline industry processes, offering enhanced communication, efficiency, and trust for clients and translators.',
  },
  [ABOUT_COMPANY_MISSION_NAMES.GOALS]: GOALS_INSTRUCTIONS,
};

const SWOT_OPPORTUNITIES_INSTRUCTIONS = {
  [SWOT_ROW_NAMES.TITLE]: {
    name: 'Opportunities',
    instruction:
      'Analyze market trends and identify opportunities matching company strengths. Discuss consumer shifts, tech advancements, and regulations. Explore leveraging these trends for market expansion, new offerings, or entering untapped segments.',
    exampleOne: ul([
      'Expansion into emerging markets with growing demand for specialized agricultural machinery.',
      'Diversification of product offerings to include complementary equipment or accessories for tracked tractors.',
      'Partnerships with agricultural research institutions or universities to explore advancements in soil management and farming techniques.',
    ]),
    exampleTwo: ul([
      'Adding the functions of oral and simultaneous translation.',
      'Leveraging AI and machine learning advancements to enhance platform capabilities further and improve translation accuracy.',
      'Expansion into new international markets with growing demand for translation services.',
    ]),
  },
};

const SWOT_THREATS_INSTRUCTIONS = {
  [SWOT_ROW_NAMES.TITLE]: {
    name: 'Threats',
    instruction:
      'Identify and analyze external threats: market trends, competition, economic downturns, regulatory uncertainties. Discuss impact on operations, market share, customer relationships. Articulate potential negative consequences and vulnerabilities.',
    exampleOne: ul([
      'Intensifying competition from larger, established manufacturers with greater resources and market presence.',
      'Regulatory changes or environmental regulations affecting the use of agricultural machinery or rubber materials.',
      'Technological advancements from competitors leading to the development of alternative solutions for challenging soil conditions.',
    ]),
    exampleTwo: ul([
      'Potential vulnerability to cybersecurity threats or data breaches due to reliance on digital platforms.',
      'Economic downturns or currency exchange rate fluctuations impact client spending on translation services.',
      'Emerging competitors or disruptive technologies are entering the market, posing a threat to market share and differentiation.',
    ]),
  },
};

const SWOT_INSTRUCTIONS = {
  [ABOUT_COMPANY_SWOT_NAMES.OPPORTUNITIES]: SWOT_OPPORTUNITIES_INSTRUCTIONS,
  [ABOUT_COMPANY_SWOT_NAMES.THREATS]: SWOT_THREATS_INSTRUCTIONS,
};

export const ABOUT_COMPANY_INSTRUCTIONS = {
  [BUSINESS_TOOL_SUB_SECTIONS.ABOUT_COMPANY.GENERAL_INFO]: GENERAL_INFO_INSTRUCTIONS,
  [BUSINESS_TOOL_SUB_SECTIONS.ABOUT_COMPANY.COMPANY_HISTORY]: COMPANY_HISTORY_INSTRUCTIONS,
  [BUSINESS_TOOL_SUB_SECTIONS.ABOUT_COMPANY.MISSION_AND_STRATEGY]: MISSION_NAMES_INSTRUCTIONS,
  [BUSINESS_TOOL_SUB_SECTIONS.ABOUT_COMPANY.SWOT]: SWOT_INSTRUCTIONS,
};
